/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Method_Content_Step_04_Detail_Beginner_0_HeadingInputs */

const en_method_content_step_04_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impact is not the end`)
};

const es_method_content_step_04_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El impacto no es el final`)
};

const de_method_content_step_04_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wirkung ist nicht das Ende`)
};

const zh_method_content_step_04_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`击球瞬间不是结束`)
};

const ar_method_content_step_04_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لحظة الضرب ليست النهاية`)
};

const fr_method_content_step_04_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L’impact n’est pas la fin`)
};

const vi_method_content_step_04_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impact không phải kết thúc`)
};

const sw_method_content_step_04_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kugonga mpira si mwisho wa swing`)
};

const th_method_content_step_04_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`จังหวะอิมแพ็คไม่ใช่จุดจบ`)
};

const bs_method_content_step_04_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impact nije kraj`)
};

const ja_method_content_step_04_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`インパクトは終わりではない`)
};

const ko_method_content_step_04_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`임팩트는 끝이 아닙니다`)
};

const pt_method_content_step_04_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O impacto não é o fim`)
};

const it_method_content_step_04_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`L'impatto non è la fine`)
};

const sv_method_content_step_04_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Träffen är inte slutet`)
};

const nl_method_content_step_04_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Het trefmoment is niet het einde`)
};

const da_method_content_step_04_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Træfmomentet er ikke slutningen`)
};

const nb_method_content_step_04_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Treffet er ikke slutten`)
};

const fi_method_content_step_04_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Osuma ei ole loppu`)
};

const pl_method_content_step_04_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uderzenie to nie koniec`)
};

const ru_method_content_step_04_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Удар — это не конец`)
};

const tr_method_content_step_04_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vuruş anı swingin sonu değildir`)
};

const hi_method_content_step_04_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इम्पैक्ट अंत नहीं है`)
};

const id_method_content_step_04_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impact bukanlah akhir ayunan`)
};

const ms_method_content_step_04_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Hentaman bukanlah penghujung hayunan`)
};

const cs_method_content_step_04_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Úder není konec`)
};

const el_method_content_step_04_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Η επαφή δεν είναι το τέλος`)
};

const he_method_content_step_04_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`הפגיעה היא לא הסוף`)
};

const af_method_content_step_04_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Impak is nie die einde nie`)
};

const hu_method_content_step_04_detail_beginner_0_heading = /** @type {(inputs: Method_Content_Step_04_Detail_Beginner_0_HeadingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A találat nem a vég`)
};

/**
* | output |
* | --- |
* | "Impact is not the end" |
*
* @param {Method_Content_Step_04_Detail_Beginner_0_HeadingInputs} inputs
* @param {{ locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }} options
* @returns {LocalizedString}
*/
export const method_content_step_04_detail_beginner_0_heading = /** @type {((inputs?: Method_Content_Step_04_Detail_Beginner_0_HeadingInputs, options?: { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Method_Content_Step_04_Detail_Beginner_0_HeadingInputs, { locale?: "en" | "es" | "de" | "zh" | "ar" | "fr" | "vi" | "sw" | "th" | "bs" | "ja" | "ko" | "pt" | "it" | "sv" | "nl" | "da" | "nb" | "fi" | "pl" | "ru" | "tr" | "hi" | "id" | "ms" | "cs" | "el" | "he" | "af" | "hu" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_method_content_step_04_detail_beginner_0_heading(inputs)
	if (locale === "de") return de_method_content_step_04_detail_beginner_0_heading(inputs)
	if (locale === "zh") return zh_method_content_step_04_detail_beginner_0_heading(inputs)
	if (locale === "ar") return ar_method_content_step_04_detail_beginner_0_heading(inputs)
	if (locale === "fr") return fr_method_content_step_04_detail_beginner_0_heading(inputs)
	if (locale === "vi") return vi_method_content_step_04_detail_beginner_0_heading(inputs)
	if (locale === "sw") return sw_method_content_step_04_detail_beginner_0_heading(inputs)
	if (locale === "th") return th_method_content_step_04_detail_beginner_0_heading(inputs)
	if (locale === "bs") return bs_method_content_step_04_detail_beginner_0_heading(inputs)
	if (locale === "ja") return ja_method_content_step_04_detail_beginner_0_heading(inputs)
	if (locale === "ko") return ko_method_content_step_04_detail_beginner_0_heading(inputs)
	if (locale === "pt") return pt_method_content_step_04_detail_beginner_0_heading(inputs)
	if (locale === "it") return it_method_content_step_04_detail_beginner_0_heading(inputs)
	if (locale === "sv") return sv_method_content_step_04_detail_beginner_0_heading(inputs)
	if (locale === "nl") return nl_method_content_step_04_detail_beginner_0_heading(inputs)
	if (locale === "da") return da_method_content_step_04_detail_beginner_0_heading(inputs)
	if (locale === "nb") return nb_method_content_step_04_detail_beginner_0_heading(inputs)
	if (locale === "fi") return fi_method_content_step_04_detail_beginner_0_heading(inputs)
	if (locale === "pl") return pl_method_content_step_04_detail_beginner_0_heading(inputs)
	if (locale === "ru") return ru_method_content_step_04_detail_beginner_0_heading(inputs)
	if (locale === "tr") return tr_method_content_step_04_detail_beginner_0_heading(inputs)
	if (locale === "hi") return hi_method_content_step_04_detail_beginner_0_heading(inputs)
	if (locale === "id") return id_method_content_step_04_detail_beginner_0_heading(inputs)
	if (locale === "ms") return ms_method_content_step_04_detail_beginner_0_heading(inputs)
	if (locale === "cs") return cs_method_content_step_04_detail_beginner_0_heading(inputs)
	if (locale === "el") return el_method_content_step_04_detail_beginner_0_heading(inputs)
	if (locale === "he") return he_method_content_step_04_detail_beginner_0_heading(inputs)
	if (locale === "af") return af_method_content_step_04_detail_beginner_0_heading(inputs)
	if (locale === "hu") return hu_method_content_step_04_detail_beginner_0_heading(inputs)
	return en_method_content_step_04_detail_beginner_0_heading(inputs)
});